import React, { createContext, useEffect } from "react";
import ReactGA from "react-ga4";
import { analytics } from "../config/firebase-config";
import { logEvent as logGAEvent } from "firebase/analytics";
import { useFirebaseAuth } from "./FirebaseAuth";

export const GoogleAnalyticsContext = createContext({
  logEvent: (
    eventNameOrCategory: string,
    parametersOrAction?: Record<string, any> | string,
    label?: string
  ) => {},
});

export function GoogleAnalyticsContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const user = useFirebaseAuth();

  useEffect(() => {
    ReactGA.initialize("G-ET0PG2LN4Z", {
      gaOptions: {
        user_id: user?.uid,
      },
    });
  }, []);

  useEffect(() => {
    if (user?.uid) {
      ReactGA.set({
        user_id: user.uid,
      });
    }
  }, [user]);

  const logEvent = (
    eventNameOrCategory: string,
    parametersOrAction?: Record<string, any> | string,
    label?: string
  ) => {
    // Check if using old format (category, action, label) or new format (eventName, parameters)
    if (typeof parametersOrAction === "string") {
      // Old format: logEvent("Category", "Action", "Label")
      const category = eventNameOrCategory;
      const action = parametersOrAction;

      // Convert to GA4 format
      const eventName =
        `${category.toLowerCase()}_${action.toLowerCase()}`.replace(
          /[^a-z0-9_]/g,
          "_"
        );
      const parameters = {
        category,
        action,
        label: label || undefined,
      };

      // Firebase Analytics (GA4 native)
      logGAEvent(analytics, eventName, parameters);

      // React GA4 (backward compatibility)
      // ReactGA.event({
      //   category,
      //   action,
      //   label,
      // });
    } else {
      // New format: logEvent("event_name", { parameters })
      const eventName = eventNameOrCategory;
      const parameters = parametersOrAction || {};

      // Firebase Analytics (GA4 native)
      logGAEvent(analytics, eventName, parameters);

      // React GA4 (using gtag format)
      // ReactGA.event(eventName, parameters);
    }
  };

  return (
    <GoogleAnalyticsContext.Provider
      value={{
        logEvent,
      }}
    >
      {children}
    </GoogleAnalyticsContext.Provider>
  );
}
